export default function deriveStatus({ shops, hasShopRow, employeesCount }) {
  if (employeesCount > 0) return "ASSIGNED";
  if (hasShopRow && shops > 0) return "UNASSIGNED";
  return "NO DATA";
}